export default __webpack_public_path__ + "static/media/hanan-ben-ari_shemesh.11233a06.mp3";